import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { StatisticsCardData, StatisticsCardType } from '@compiere-ws/models/apiz-domains';
import { LoadingDirective } from '@iupics-components/directives/loading.directive';
import { NumberAnimationDirective } from '@iupics-components/directives/number-animation.directive';
import { SecurityManagerService } from '@iupics-manager/managers/security-manager/security-manager.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'iu-statistics-card',
  templateUrl: './statistics-card-ui.component.html',
  styleUrls: ['./statistics-card-ui.component.scss'],
  standalone: true,
  imports: [NgClass, LoadingDirective, NumberAnimationDirective, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class StatisticsCardUiComponent {
  protected connectorService = inject(SecurityManagerService);

  readonly stats = input<StatisticsCardData>();
  readonly currency = input<string>();

  readonly isCount = computed(() => this.stats()?.type === StatisticsCardType.COUNT);
  readonly formatter = computed(() => {
    return Intl.NumberFormat(this.connectorService.getIupicsUserContext()['#AD_Language'].slice(0, 2), {
      notation: 'compact',
      style: 'currency',
      currency: this.currency() ?? this.connectorService.getIupicsUserContext()['$CurrencyISO'],
    });
  });

  animatedData: any = {};
  animateData = false;

  setAnimateDataState(event: any): void {
    if (!event) {
      this.animateData = true;
    }
  }

  bindAnimatedValue(value: number, columnName: string): void {
    this.animatedData[columnName] = value;
  }
}
